// extracted by mini-css-extract-plugin
module.exports = {"date-column":"date-column___2iGIm","flagged":"flagged___eEL67","actions-column":"actions-column___3lEQw","dropdown-icon":"dropdown-icon___1eF4v"};